var map = {
	"./ciasto.jpeg": 7628,
	"./ciasto_s.jpeg": 6765,
	"./dzieci_klopsy.jpeg": 7103,
	"./dzieci_klopsy_s.jpeg": 6661,
	"./dzieci_plince.jpeg": 6537,
	"./dzieci_plince_s.jpeg": 8653,
	"./dzieci_poledwiczki.jpeg": 7053,
	"./dzieci_poledwiczki_s.jpeg": 5007,
	"./flaczki.jpeg": 9533,
	"./flaczki_s.jpeg": 8737,
	"./frikase.jpeg": 8435,
	"./frikase_s.jpeg": 8483,
	"./golce.jpeg": 6263,
	"./golce_s.jpeg": 7055,
	"./grzanki.jpeg": 7630,
	"./grzanki_s.jpeg": 4411,
	"./herbata_cytrus.jpeg": 6978,
	"./herbata_cytrus_s.jpeg": 1617,
	"./herbata_maliny.jpeg": 2851,
	"./herbata_maliny_s.jpeg": 7318,
	"./herbata_rumianek.jpeg": 9637,
	"./herbata_rumianek_s.jpeg": 8968,
	"./herbata_wisniowka.jpeg": 8015,
	"./herbata_wisniowka_s.jpeg": 7765,
	"./kugle.jpeg": 8757,
	"./kugle_s.jpeg": 2549,
	"./pieklo_kaczka.jpeg": 1643,
	"./pieklo_kaczka_s.jpeg": 3603,
	"./pierogi_wege.jpeg": 6636,
	"./pierogi_wege_s.jpeg": 8686,
	"./plince_slodkie.jpeg": 516,
	"./plince_slodkie_s.jpeg": 4056,
	"./plince_wege.jpeg": 4656,
	"./plince_wege_s.jpeg": 8607,
	"./pstrag.jpeg": 2044,
	"./pstrag_s.jpeg": 8730,
	"./rosol.jpeg": 5988,
	"./rosol_s.jpeg": 3213,
	"./sledz.jpeg": 7209,
	"./sledz_s.jpeg": 156,
	"./smalec.jpeg": 8940,
	"./smalec_s.jpeg": 3201,
	"./wolowina.jpeg": 5730,
	"./wolowina_s.jpeg": 4375,
	"./zupa_muszt.jpeg": 2611,
	"./zupa_muszt_s.jpeg": 2415,
	"./zylc.jpeg": 4785,
	"./zylc_s.jpeg": 1892
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9527;